import styled from 'styled-components'
import { DEVICE_SIZE } from 'utils/breakpoints'

export const StyledVoteContainer = styled.div`
  width: 550px;
  height: 200px;

  @media ${DEVICE_SIZE.desktop} {
    width: 750px;
    height: 250px;
  }
`
